import lodash from "lodash";
import { useCallback } from "react";
import useModalCanBeSeen from "../../../utils/useModalCanBeSeen";
import HBModel from "../../HBModal";
import Editor from "./Editor";

export default function ModalWrapper(props) {
  const editorConfigs = ["pinId", "onOk", "onCancel"];
  const { visible, onCancel, onDelete } = props;
  const { id, setCanBeSeen } = useModalCanBeSeen();
  const _onDelete = useCallback(() => {
    onDelete && onDelete();
    onCancel && onCancel();
  }, [onDelete, onCancel]);

  return (
    <HBModel
      {...lodash.omit(props, editorConfigs)}
      wrapClassName={id}
      visible={visible}
      footer={null}
      bodyStyle={{ padding: 0 }}
      width={719}
      onCancel={onCancel}
      destroyOnClose
    >
      {!!visible && (
        <Editor
          {...lodash.pick(props, editorConfigs)}
          onDelete={_onDelete}
          setCanBeSeen={setCanBeSeen}
        />
      )}
    </HBModel>
  );
}
